import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import * as c from '../../../../constant';
import * as actions from '../../../../action';

function UpdateDetailsModal({
  updateDetails,
  getDetailsList,
  updateList,
  detailsId,
  newTaxRevenuesId,
  calculationsId,
  updating,
}) {
  const [formData, setFormData] = useState({
    in_excess_of: '',
    for_every: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    in_excess_of: 'required|amount_zero',
    for_every: 'required|amount_zero',
    amount: 'required|amount_zero',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateDetails(newTaxRevenuesId, calculationsId, detailsId, formData, () => {
      setModal({ isOpen: false });
      getDetailsList(newTaxRevenuesId, calculationsId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        in_excess_of: _.get(updateList, 'in_excess_of').toString(),
        for_every: _.get(updateList, 'for_every').toString(),
        amount: _.get(updateList, 'amount').toString(),
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA_DETAILS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              In Excess Of: {validateForm.renderMessage('in_excess_of')}
            </label>
            <NumberFormat
              name="in_excess_of"
              id="in_excess_of"
              className="form-control"
              placeholder="Ex. 0.00"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  in_excess_of: `${floatValue || ''}`,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'in_excess_of', '')}` || ''}
              isAllowed={(values) => {
                const { value } = values;
                return value === '' || value <= 999999999999999;
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              For Every: {validateForm.renderMessage('for_every')}
            </label>
            <NumberFormat
              name="for_every"
              id="for_every"
              className="form-control"
              placeholder="Ex. 0.00"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  for_every: `${floatValue || ''}`,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'for_every', '')}` || ''}
              isAllowed={(values) => {
                const { value } = values;
                return value === '' || value <= 999999999999999;
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0.00"
              className="mt-1 form-control"
              onValueChange={(values) => {
                const { value } = values;
                setFormData({
                  ...formData,
                  amount: value,
                });
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateDetailsModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  detailsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DETAILS_SANITARY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateDetailsModal);
